import script from "./ChangeApproveStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeApproveStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangeApproveStatusModal.vue?vue&type=style&index=0&id=7089d992&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7089d992"]])

export default __exports__